import FindUs from '../Data/FindUs'

function Find() {
    return (
        <>
        {FindUs.map((find) => (
        <div>
            <div className="flex xl:flex-row flex-col my-32 justify-between w-full gap-20">
                <div className=" md:text-8xl text-5xl font-mono">Find Us</div>
                <div className=" md:text-4xl text-xl font-mono max-w-2xl">
                {find.desc}
                </div>
            </div>

            <div className="w-full h-full rounded-3xl bg-slate-700">
                <img src={find.map} alt="" className="w-full h-full rounded-3xl object-scale-down"/>

            </div>
        </div>
        
        ))}
        </>
    )}


export default Find;